import React, { useMemo } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Circle, CircleMarker } from 'react-leaflet';
import L from 'leaflet';

// Fix default marker icon in webpack builds
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const TYPE_COLOR = {
  competencia_directa: '#b91c1c',
  competencia_indirecta: '#b45309',
  complementario: '#15803d',
  generador_trafico: '#1e3a8a',
  actividad_no_relevante: '#94a3b8',
};

const TYPE_LABEL = {
  competencia_directa: 'Competencia directa',
  competencia_indirecta: 'Competencia indirecta',
  complementario: 'Complementario',
  generador_trafico: 'Generador tráfico',
  actividad_no_relevante: 'Actividad no relevante',
};

export default function MapView({ analysis }) {
  const loc = analysis.location || {};
  const center = [loc.center_lat || 23.6345, loc.center_lon || -102.5528];
  const radiusMeters = (loc.radius_km || 5) * 1000;
  const est = (analysis.establishments || []).filter((e) => e.lat && e.lon);

  const legend = Object.entries(TYPE_LABEL).map(([k, l]) => ({ key: k, label: l, color: TYPE_COLOR[k] }));

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <div className="label-caps">Mapa territorial</div>
        <div className="flex flex-wrap gap-3">
          {legend.map((it) => (
            <div key={it.key} className="flex items-center gap-1 text-xs text-slate-600">
              <span className="w-3 h-3 rounded-full" style={{ backgroundColor: it.color }} />
              {it.label}
            </div>
          ))}
        </div>
      </div>
      <div style={{ height: 520 }} className="border border-slate-200 overflow-hidden">
        <MapContainer center={center} zoom={12} style={{ height: '100%', width: '100%' }} scrollWheelZoom>
          <TileLayer
            attribution='&copy; OpenStreetMap contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Circle center={center} radius={radiusMeters} pathOptions={{ color: '#1e3a8a', fillOpacity: 0.05, weight: 1 }} />
          <Marker position={center}>
            <Popup>
              <strong>{loc.state_name}</strong><br />
              {(loc.municipality_names || []).join(', ')}<br />
              Radio: {loc.radius_km} km
            </Popup>
          </Marker>
          {est.map((e, i) => (
            <CircleMarker
              key={i}
              center={[e.lat, e.lon]}
              radius={7}
              pathOptions={{ color: TYPE_COLOR[e.type] || '#64748b', fillColor: TYPE_COLOR[e.type] || '#64748b', fillOpacity: 0.7 }}
            >
              <Popup>
                <strong>{e.name}</strong><br />
                {e.category}<br />
                <span style={{ color: TYPE_COLOR[e.type] }}>{TYPE_LABEL[e.type] || e.type}</span><br />
                <em>{e.employees_range}</em>
              </Popup>
            </CircleMarker>
          ))}
        </MapContainer>
      </div>
    </div>
  );
}
